// The one product this dashboard manages: Flovingo, served by the backend that
// replaced flovingo-backend (speaking-trainer-project/backend, D137). There is
// no product switcher any more; this module only says where that backend is and
// which names its sessions use.
//
// The key, the refresh-token cookie and the partner-token key keep Flovingo's
// original names, so sessions stored under them are still found.
export type AppKey = 'flovingo';

type ManagedApp = {
    key: AppKey;
    label: string;
    apiBaseUrl: string | undefined;
    refreshCookie: string;
    partnerTokenKey: string;
};

const isDevelopment = process.env.REACT_APP_IS_PRODUCTION === 'development';

// Development: REACT_APP_TRAINER_API_BASE_URL when it is set (a local backend,
// usually http://localhost:4500), otherwise REACT_APP_API_BASE_URL.
// Production: REACT_APP_API_BASE_PRODUCTION_URL, the same endpoint as before.
const apiBaseUrl = isDevelopment
    ? process.env.REACT_APP_TRAINER_API_BASE_URL || process.env.REACT_APP_API_BASE_URL
    : process.env.REACT_APP_API_BASE_PRODUCTION_URL;

export const APP: ManagedApp = {
    key: 'flovingo',
    label: 'Flovingo',
    apiBaseUrl,
    refreshCookie: 'refresh_token',
    partnerTokenKey: 'flovingo_partner_token',
};

export const currentApp = (): ManagedApp => APP;
